import createPusherEventHandlersForService from 'shared/clients/pusher/createPusherEventHandlersForService.js';
import { SOURCES_SERVICE_KEY } from 'web/sources/sourcesEnum';

export default createPusherEventHandlersForService(SOURCES_SERVICE_KEY);
